import { useI18n } from '~/common/context';

import { get } from 'lodash-es';

import { Controller, useFormContext } from 'react-hook-form';
import {
  type ISelectOption,
  Button,
  Flex,
  FormFeedback,
  FormGroup,
  Label,
} from '@wyz/ui';
import clsx from 'clsx';
import { TranslationKeys } from '~/common/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import './dimension-field.scss';
import React from 'react';
type DimensionFieldProps = {
  id?: string;
  name: string;
  helperText?: string;
  label?: React.ReactNode;
  defaultValue?: string | Array<string>;
  required?: boolean;
  options: Array<ISelectOption<number | string>>;
  /**
   * Only used to notify the parent about change, NOT to control the component
   */
  onSelect?: (selectValue: string | number) => void;
};

function DimensionField({
  onSelect,
  name,
  options,
  helperText,
  id,
  label,
  required,
}: DimensionFieldProps) {
  const { t } = useI18n();
  const {
    formState: { errors, defaultValues },
    control,
  } = useFormContext();

  const names = name.split('.');
  const errorMessage = (get(errors, [...names, 'message']) ||
    get(errors, [names[0], 'message'])) as keyof TranslationKeys;

  return (
    <FormGroup className='dimension-field'>
      {label && (
        <Label
          htmlFor={id || name}
          className={clsx({
            required: required,
          })}
        >
          {label}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        defaultValue={get(defaultValues, name)}
        render={({ field }) => {
          return (
            <Flex wrap='wrap'>
              {options.map((option) => (
                <div
                  key={option.value}
                  className='mt-1 me-1'
                  style={{ width: 50 }}
                >
                  <Button
                    id={option.label}
                    onClick={() => {
                      field.onChange(option.value);
                      onSelect?.(option.value);
                    }}
                    variant={
                      field.value === option.value ? 'primary' : 'secondary'
                    }
                    fullWidth
                  >
                    {option.value}
                  </Button>
                </div>
              ))}
            </Flex>
          );
        }}
      />
      {errorMessage ? (
        <FormFeedback invalid id={`${name}.error`}>
          {t(errorMessage)}
        </FormFeedback>
      ) : helperText ? (
        <FormFeedback>{helperText}</FormFeedback>
      ) : null}
    </FormGroup>
  );
}

export default DimensionField;
